var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5H2C1.72386 18.5 1.5 18.2761 1.5 18V7.62904C1.5 7.43936 1.55992 7.25454 1.67122 7.10095L4.85544 2.70662C4.94948 2.57683 5.10004 2.5 5.26032 2.5H16.7397C16.9 2.5 17.0505 2.57683 17.1446 2.70662L20.3288 7.10095C20.4401 7.25454 20.5 7.43936 20.5 7.62904V18C20.5 18.2761 20.2761 18.5 20 18.5Z",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.4375H7.97624C7.99026 7.4375 8.00253 7.4469 8.00618 7.46044V7.46044C8.83026 10.519 13.1697 10.519 13.9938 7.46044V7.46044C13.9975 7.44691 14.0097 7.4375 14.0238 7.4375H20",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyOutline);
export default __webpack_public_path__ + "static/media/ic_my_outline.88622073f229de2cb6726349037081bb.svg";
export { ForwardRef as ReactComponent };